import {useMutation, useQueryClient} from '@tanstack/react-query'
import {useSnackbar} from 'notistack'
import api from 'src/services/api'
import {CreateFace} from 'src/services/api/endpoints/FacialRecognitionEndpoint'
import {QueryKeyEnum} from 'src/utilities/enums/QueryKeyEnum'
import handleErrorWithSnackbar from 'src/utilities/handleErrorWithSnackbar'

export default function useCreateFace() {
  const {enqueueSnackbar} = useSnackbar()
  const client = useQueryClient()
  const mutation = useMutation({
    mutationKey: [QueryKeyEnum.CREATE_FACE],
    mutationFn: async (body: CreateFace) => {
      const formData = new FormData()
      formData.append('name', body.name)
      formData.append('lists_ids', JSON.stringify(body.listsIds))
      if (body.images) {
        for (const image of body.images) formData.append(`face_images`, image)
      }

      return await api.facialRecognition.createFacial(formData)
    },
    onSuccess: async () => {
      await client.invalidateQueries({queryKey: [QueryKeyEnum.FACE_DETECTIONS]})
      enqueueSnackbar('Face criada com sucesso', {variant: 'success'})
    },
    onError: (error) => {
      handleErrorWithSnackbar(enqueueSnackbar, error, 'Erro ao cadastrar face')
    },
  })
  return mutation
}
